import { useQuery } from '@tanstack/react-query';
import { FaqApi } from 'shared/api/faq';

export const useFaqQuery = () => useQuery({
    queryKey: ['faq'],
    queryFn: () => FaqApi.fetchAll().then(d => d.data.data)
});
